export default "__VITE_ASSET__D5U814hb__"